import React from "react";
import UlLi, {scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import ApptokenDisplay from "js/utilities/get-display-apptoken";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar";

import ENCRYPTION_KEYS_SWIFT from "resources/code/ios/encryption-keys.swift.tpl";
import ENCRYPTION_KEYS_OBJC from "resources/code/ios/encryption-keys.m.tpl";
import ENCRYPTION_KEY_JAVA from "resources/code/hybrid/android/07-set-encryption-key.java.tpl";
import ENCRYPTION_KEY_JAVA_SERVER from "resources/code/ios/encryption-keys.java.tpl";
import ENCRYPTION_KEY_JS from "resources/code/ios/encryption-keys.js.tpl";
import SDK_INITIALIZE_SWIFT from "resources/code/quickstart/ios/00-initialize.swift.tpl";
import SDK_INITIALIZE_OBJC from "resources/code/quickstart/ios/00-initialize.m.tpl";
import SDK_IMPORT_SWIFT from "resources/code/quickstart/ios/01-import.swift.tpl";
import SDK_IMPORT_OBJC from "resources/code/quickstart/ios/01-import.m.tpl";
import SDK_START_ENROLLMENT_SWIFT from "resources/code/quickstart/ios/02-start-enrollment.swift.tpl";
import SDK_START_ENROLLMENT_OBJC from "resources/code/quickstart/ios/02-start-enrollment.m.tpl";
import ON_BEFORE_DISMISS_SWIFT from "resources/code/ios/37-exit-animations.swift.tpl";
import ON_BEFORE_DISMISS_OBJC from "resources/code/ios/37-exit-animations.m.tpl";


export default React.createClass({
  displayName: "ios-guide",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var data  = [
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data: data,
      navMenuParent: null,
      navMenu: null,
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    var formattedSubject = "FaceTec Usage Log Review Request";
    var formattedBody = "Hello FaceTec Support,\n\n I am ready for you to check the Usage Logs for our account.  I have verified that Usage Logs are being uploaded for all instances of the FaceTec Server SDK and will be uploaded on a daily basis from now on.";

    var mailToLink = "mailto:support@facetec.com?subject=" + formattedSubject + "&body=" + encodeURIComponent(formattedBody);

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">
              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="usage-logs">Usage Logs</h2>
                </div>
                <p>This guide discusses configuring Usage Logs to be sent to FaceTec when in Production.</p>
                <hr/>
              </section>

              <section>
                <h3 id="overview">Overview</h3>
                <p><strong>FaceTec must be able to count your usage of the SDKs in your Applications.</strong>  Although FaceTec Production Keys allow your Apps to operate without contacting FaceTec Servers, FaceTec still must be able to count Server SDK Usage of your Production App.  This guide explains our policies and reasoning, and more about the logs themselves.</p>
                <hr />
              </section>

              <section>
                <h3 id="usage-log-policy">Usage Log Policy</h3>
                <ul>
                  <li><p><strong>FaceTec must receive all anonymous, non-PII Usage Logs from all instances of your Server SDKs, no exceptions.</strong></p></li>
                  <li><p>Usage Logs must be gathered via automation and <strong>sent to FaceTec on a daily basis</strong>.</p></li>
                  <li><p><strong>You can set your backend log collection and upload system any way you please</strong>, so you can have full transparency into the system that is sending data to FaceTec. You may gather the logs via any method that you want based on your knowledge of your own infrastructure.  The Server SDK can be deployed to an endless amount of cloud architecture combinations, and we are not not familiar with the particulars of your cloud architecture.</p></li>
                  <li><p><strong>FaceTec checks Usage Logs for tampering, missing logs, and anomalies,</strong> and will reach out to you and work with you if these are detected.</p></li>
                </ul>
                <hr />
              </section>

              <section>
                <h3 id="prereq-production">Prerequisite for Production</h3>
                <p>Usage Log configuration is a prerequisite for <Link to="/going-production-overview">Going Production</Link>, and must be set up correctly and verified by FaceTec before <Link to="/licensing">Production Keys</Link> can be issued.  Once you are ready for us to check your Usage Logs, <a href={mailToLink}>Contact Us for final review and confirmation</a>.  We will take a look at your account and issue FaceTec Production Keys immediately if everything is set up correctly.</p>
              </section>

              <hr />

              <section>
                <h3 id="log-output">Gathering Log Output</h3>
                <p><strong>The FaceTec Server SDK simply logs things to stdout.  There are numerous ways to capture this, depending on your infrastructure.</strong></p>
                <blockquote><p><strong>Why doesn't FaceTec provide an automatic method for Usage Log upload?</strong></p>
                <p>FaceTec does not provide an automatic log-gathering mechanism and relies on the ultra-flexible log emitting mechanism of stdout to allow you to configure in any fashion you like. FaceTec is deployed into many very large organizations, banks, financial institutions, governments, and more.  Most large entities have specific and highly varying security requirements, philosophies, and levels of sophistication. Emitting to stdout provides the highest degree of flexibility in terms of server-side app architecture, and gives you transparency into the handling of data that you will be sending outside of your networks.</p>
                <p>FaceTec plans to provide additional features and tools to gather and send Usage Logs by Q3 2020.</p>
                </blockquote>
                <hr />
              </section>

              <section>
                <h3 id="configurations">Configurations</h3>
                <p>The following are possible ways to configure Usage Log transfer based on your backend architecture:</p>

                <ul>
                  <li><p>If you are using AWS, activate CloudWatch and configure a process to SFTP your CloudWatch logs on a daily basis.</p></li>
                  <li><p>If you are using Azure, activate Monitor and configure a process to SFTP your Monitor logs on a daily basis.</p></li>
                  <li><p>Google Cloud, activating Stackdriver and configure a process to SFTP your Stackdriver logs on a daily basis.</p></li>
                  <li><p>If you are using a custom environment, you can configure your servers to log FaceTec Server process stdout to log files.  Then set up a cron job to SFTP these Usage Logs to FaceTec on a daily basis.</p></li>
                </ul>
                <hr />
              </section>

              <section>
                <h3 id="security">Usage Log Transfer Security</h3>
                <p>SFTP is a secure, widely-used, and mature technology. FaceTec uses <a href="https://aws.amazon.com/aws-transfer-family/faqs/" target="_blank">AWS Transfer Family</a> as its provider of SFTP services.  AWS Transfer Family is PCI-DSS and GDPR compliant, and HIPAA eligible. The service is also SOC 1, 2, and 3 compliant.</p>
                <hr />
              </section>

              <section>
                <h3 id="generating-ssh-keys-and-testing-sftp-upload">Generating SSH Keys and Testing SFTP Upload</h3>
                <p>Your automated Usage Log process that gathers your logs and sends them via SFTP will connect to an account that is generated by FaceTec.  Establishing a secure connection requires that you generate a standard SSH public/private key pair.</p>
                <p>To create your SSH public/private keys, please follow the steps below:</p>
                <ul>
                  <li><p>To create your private key, run: <code>openssl genrsa > SFTP_Private_Key.pem</code></p></li>
                  <li><p>Change permissions to SFTP_Private_Key.pem to read/write only: <code>chmod 600 SFTP_Private_Key.pem</code></p></li>
                  <li><p>To create your public key, run: <code>ssh-keygen -y -f SFTP_Private_Key.pem > SFTP_Public_Key.pub</code></p></li>
                </ul>

                <blockquote>
                  <p><strong>Windows Users</strong>: Please see <a target="_blank" href="https://tutorials.ubuntu.com/tutorial/tutorial-ssh-keygen-on-windows#3">this guide</a> for a quick guide to creating your public/private key pair.</p>
                </blockquote>

                <p>Next, simply upload the <strong>public</strong> part of your key to your Application Details in your <Link to="/account">Account Page</Link>. </p>

                <p>Upon success, you will be able to upload files using the following connection details:</p>
                <ul>

                  <li><p><strong>username:</strong> <code>YOUR_ASSIGNED_USERNAME</code> (find this on the Application Details of your <Link to="/account">Account Page</Link>)</p></li>
                  <li><p><strong>host:</strong> <code>logs.facetec.com (54.70.182.147)</code></p></li>
                  <li><p><strong>port:</strong> <code>22</code></p></li>
                </ul>

                <blockquote>
                  <p><strong>Upload a test file (Mac terminal, Linux, or Windows Powershell):</strong></p>
                  <p>Run <code>echo 'put /path/to/testfile.txt' | sftp YOUR_ASSIGNED_USERNAME@54.70.182.147</code> from the machine(s) with the private SSH key corresponding to the public SSH key that you configured.</p>
                </blockquote>

                <p>SSH Keys for SFTP Upload are required for:</p>
                <ul>
                  <li><p>All Production FaceTec Partners & Customers in order to send FaceTec Usage Logs from all instances of FaceTec Server.</p></li>
                </ul>

                <hr />

                <h3 id="usage-log-format">Usage Log Format</h3>

                <p>Please upload logs in a flat directory and name the log files with the naming convention <code>facetec-usage-logs-[DATE]-[Server ID or Guid].txt</code>.  If you have multiple instances of FaceTec Server running, please append a unique identifier after the <code>[DATE]</code> so the log files are uniquely named or you will get conflicts when uploading.</p>

                <hr />

                <h3 id="usage-log-contents">Usage Log Contents</h3>

                <p>The FaceTec Server SDK outputs one or more log lines per User Session or function call. All FaceTec Server Core SDK Usage Logs must be uploaded to your SFTP Account.  Altering logs is not allowed.</p>

                <blockquote><p>Note: FaceTec Server Core Usage Logs start with the string <code>ZOS_c4a3j1v5dxlwpwmy1u</code>.  FaceTec considers these log lines the "Usage Logs", and these are the logs that must be sent to FaceTec.  FaceTec REST Sample code and FaceTec Standard Server output additional logs that are not required to be sent to FaceTec.</p></blockquote>

                <p>Logs are emitted for the FaceTec Server SDK on each transaction to Standard Out (stdout) for maximum flexibility. You can use any log capture and aggregation system to configure your backend systems to capture and save this data in a manner that is best for their own infrastructure.

                FaceTec Usage Logs do not contain personally identifiable information. FaceTec Usage Logs do contain the following information:
                </p>
                <br />
                <ul>
                  <li><p>Machine ID</p></li>
                  <li><p>Key Identifier</p></li>
                  <li><p>Timestamps</p></li>
                  <li><p>Log Anti-Tampering Hash</p></li>
                  <li><p>Installation ID of FaceMap 1</p></li>
                  <li><p>Installation ID of FaceMap 2</p></li>
                  <li><p>Session ID of FaceMap 1</p></li>
                  <li><p>Session ID of FaceMap 2</p></li>
                  <li><p>Transaction Type (Liveness, Match3D_3D, prepareAndUpdateFaceMap, etc.)</p></li>
                  <li><p>FaceTec Server Version</p></li>
                  <li><p>Server Stages</p></li>
                  <li><p>FaceTec Server Version FaceMap 1 Created With</p></li>
                  <li><p>FaceTec Server Version FaceMap 2 Created With</p></li>
                  <li><p>FaceTec Server Version FaceMap 2 Created With</p></li>
                  <li><p>FaceMap 1 Type (iOS/Android/Browser/Single Image)</p></li>
                  <li><p>FaceMap 2 Type (iOS/Android/Browser/Single Image)</p></li>
                  <li><p>FaceMap 1 App/Package/Domain</p></li>
                  <li><p>FaceMap 2 App/Package/Domain</p></li>
                  <li><p>FaceMap 1 Device Version</p></li>
                  <li><p>FaceMap 2 Device Version</p></li>
                  <li><p>FaceMap 1 Client Device Tier</p></li>
                  <li><p>FaceMap 2 Client Device Tier</p></li>
                  <li><p>FaceMap 1 Client Session Elapsed Time</p></li>
                  <li><p>FaceMap 2 Client Session Elapsed Time</p></li>
                  <li><p>License Type Being Used</p></li>
                  <li><p>FaceMap 1 Session Token Status</p></li>
                  <li><p>FaceMap 2 Session Token Status</p></li>
                  <li><p>FaceMap 1 Liveness Result</p></li>
                  <li><p>FaceMap 2 Liveness Result</p></li>
                  <li><p>FaceMap 1 Anonymous Session Result Data</p></li>
                  <li><p>FaceMap 2 Anonymous Session Result Data</p></li>
                  <li><p>Result (ZoomError, ZoomCreationStatus, ZoomAuthenticationResult) - i.e. success, retry, or error</p></li>
                </ul>

                <p>
                  The following is an example of a log line from the FaceTec Server SDK:<br /><br />

                  <code>ZOS,MID:[MACHINE ID],LKI:[Key IDENTIFIER],DT:[TIMESTAMP],SIG:[STAT SIGNATURE],IID1:[INSTALLATION ID 1],IID2:[INSTALLATION ID 2],SID1:[SESSION ID 1],SID2:[SESSION ID 2],TT:[TRANSACTION TYPE (prepare,authenticate,etc...)],ZSV:[FACETEC SERVER VERSION],SS:[SERVER STAGES],ZWF1:[SERVER VERSION FACEMAP 1 WAS CREATED WITH],ZWF2:[SERVER VERSION FACEMAP 1 WAS CREATED WITH],ZCST1:[FACEMAP 1 TYPE (iOS/Android/Web/Single Image)],ZCST2:[FACEMAP 2 TYPE (iOS/Android/Web/Single Image)],ZCPI1:[FACEMAP 1 PACKAGE ID],ZCPI2:[FACEMAP 2 PACKAGE ID],ZCDV1:[FACEMAP 1 DEVICE VERSION],ZCDV2:[FACEMAP 2 DEVICE VERSION],ZCDT1:[FACEMAP 1 CLIENT DEVICE TIER],ZCDT2:[FACEMAP 2 CLIENT DEVICE TIER],ZCSS1:[FACEMAP 1 CLIENT SESSION ELAPSED TIME],ZCSS2:[FACEMAP 2 CLIENT SESSION ELAPSED TIME],ZSLS:[BOOLEAN IS CUSTOMER SFTP],ZSTS1:[FACEMAP 1 SESSION TOKEN STATUS],ZSTS2:[FACEMAP 2 SESSION TOKEN STATUS],ZSLR1:[FACEMAP 1 LIVENESS RESULT],ZSLR2:[FACEMAP 2 LIVENESS RESULT],ZSLD1:[FACEMAP 1 ANONYMOUS SESSION RESULT DATA],ZSLD2:[FACEMAP 2 ANONYMOUS SESSION RESULT DATA],R:[RESULT OF TRANSACTION(ZoomCreationStatus+ZoomError from transaction)]</code>

                </p>

                <blockquote><p>Please Note:  Anonymous Session Result Data String does not contain PII and is required so that FaceTec can analyze if there are issues with Sessions that are being performed.  The data is anonymous and does not contain biometric data, image data, age/gender/ethnicity data, or any other PII.  The String is an encoded and scrambled set of floating point number responses from over 60 algorithms that run on every session testing liveness, quality, and other security checks.  The String also contains Binary Flags and Enums that relate to security checks the FaceTec SDKs perform for stream tampering, virtual cameras, and other potential bypasses.</p></blockquote>

             </section>

          </div>

          <SDKSidebar menuType="main" title="Encryption Keys"/>

        </div>
      </div>
    </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/usage-logs.jsx